export const SUGGESTED_QUESTIONS = [
  'pages.home.supportModal.suggestedQuestions.passwordReset',
  'pages.home.supportModal.suggestedQuestions.noInternet',
  'pages.home.supportModal.suggestedQuestions.emailNotWorking',
  'pages.home.supportModal.suggestedQuestions.printerIssue',
  'pages.home.supportModal.suggestedQuestions.appCrashing'
] as const;
